
export const libraryService = {
  /**
   * Mapeamento de Dificuldade (Flesch para CEFR).
   * 90-100 = A1 | 80-89 = A2 | 70-79 = B1 | 60-69 = B2 | 50-59 = C1 | <50 = C2.
   */
  mapReadingLevelToCefr(value: string | number | undefined): string {
    if (value === undefined || value === null) return 'Nível: --';
    
    // Extrai o valor numérico do início da string (ex: "73.3" -> 73.3)
    const strValue = String(value);
    const match = strValue.match(/^(\d+\.?\d*)/);
    if (!match) return 'Nível: --';
    
    const score = parseFloat(match[1]);
    
    if (score >= 90) return 'Iniciante - A1';
    if (score >= 80) return 'Básico - A2';
    if (score >= 70) return 'Intermediário - B1';
    if (score >= 60) return 'Avançado - B2';
    if (score >= 50) return 'Fluente - C1';
    return 'Mestre - C2';
  },

  /**
   * Filtro Inteligente de Tags.
   * Prioridade: 'Fiction', 'Stories', 'Adventure', 'History', 'Drama', 'Poetry'.
   * Limpeza: Remove termos técnicos e sufixos '-- Fiction'.
   */
  filterTags(subjects: string[] | undefined): string[] {
    if (!subjects || !Array.isArray(subjects)) return [];
    
    const priorityTerms = ['Fiction', 'Stories', 'Adventure', 'History', 'Drama', 'Poetry'];
    
    const cleanedTags = subjects
      .map(tag => {
        // Remove sufixo '-- Fiction' e limpa espaços
        let cleaned = tag.replace(/-- Fiction$/i, '').trim();
        // Remove códigos alfanuméricos tipo "PS3515.E37" ou termos técnicos curtos tipo "PS"
        if (/^[A-Z]{1,2}\d+(\.\d+)?/.test(cleaned) || cleaned.length <= 2) return null;
        // Remove termos chatos
        if (cleaned.toLowerCase().includes('fictitious character')) return null;
        return cleaned;
      })
      .filter((tag): tag is string => tag !== null);

    // Remove duplicatas
    const uniqueTags = Array.from(new Set(cleanedTags));

    // Ordena por prioridade
    const sortedTags = uniqueTags.sort((a, b) => {
      const aPriority = priorityTerms.some(term => a.toLowerCase().includes(term.toLowerCase()));
      const bPriority = priorityTerms.some(term => b.toLowerCase().includes(term.toLowerCase()));
      if (aPriority && !bPriority) return -1;
      if (!aPriority && bPriority) return 1;
      return 0;
    });

    return sortedTags.slice(0, 3);
  }
};
